var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"aba-lists"},[_vm._l((_vm.items),function(item,key){return [_c('v-list-item',{key:key},[(_vm.hasLeft)?[_vm._t("left",null,{"item":item})]:_vm._e(),_c('v-list-item-content',[_vm._t("default",null,{"item":item})],2),(_vm.hasRight)?[_vm._t("right",null,{"item":item})]:_vm._e()],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }